import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';

import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { openWorkshopReassignmentDialog } from '../../modal/workshop-reassignment-dialog/workshop-reassignment-dialog.component';
import { wrCallList } from './wrCallList';




@Component({
	selector: 'app-workshop-reassignment',
	templateUrl: './workshop-reassignment.component.html',
	styleUrls: [ './workshop-reassignment.component.scss' ]
})
export class WorkshopReassignmentComponent implements OnInit {
	@ViewChild(MatSort, { static: true })
	sort: MatSort;
	@ViewChild(MatPaginator, { static: true })
	paginator: MatPaginator;

	displayedColumns: string[] = [
		'customerName',
		'vin',
		'contactNumber',
		'leadGenerationDate',
		'previousWorkshop',
		'SMERemarks',
		'reassignmentStatus',
	];

	spinner: boolean;
	dataSource: any;
	pageSize: number;
	filteredDataSource: any;
	uniqueRequest = new Set<string>();
	uniqueSourceId = new Set<string>();
	listSize: number = 0;

    constructor(private commonService: CommonService, private toastr: ToastrService, public dialog: MatDialog)
    {

	}

	ngOnInit() {
		if (localStorage.getItem('wrcallListPageSize') != null || localStorage.getItem('wrcallListPageSize') != undefined) {
			let pagesize = Number(localStorage.getItem('wrcallListPageSize'));
			this.pageSize = (pagesize && !Number.isNaN(pagesize)) ? pagesize : 50;
		  } else {
			this.pageSize = 50;
		  }
		this.workshopReassignmentList();

	}

	workshopReassignmentList(){
		this.spinner = true;
		this.dataSource = '';

		this.commonService.workshopReassignmentList().subscribe(res => {
			if (res['responseCode'] == 0 && res['responseData'] != undefined) {
			  this.listSize = res['responseData'].length;
			  this.dataSource = new MatTableDataSource<wrCallList>(res['responseData']);
			  this.sort.direction='';
			  this.dataSource.sort = this.sort;
			  this.dataSource.sortingDataAccessor = (data, header) => data[header];
			  this.dataSource.paginator = this.paginator;
			  this.spinner = false;
		    } else {
			  this.spinner = false;
			  this.toastr.error(res['message'], 'Error');
			  // this.callToggleStatus = true;
		    }
	    },
	    (err) => {
		  this.spinner = false;
		  this.toastr.error('Something went wrong, Please try again.', 'Error');
		  // this.callToggleStatus = true;
	    }
	    );
	}

	/**
   * Name: searchfilter
   * purpose: To apply filter on datagrid
   */
	searchfilter(filterValue: string): void {
		filterValue = filterValue.trim(); // Remove whitespace
		filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
		this.dataSource.filter = filterValue;
	}

	 /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
	setPageData(event) {
		let size = event.pageSize.toString();
		localStorage.setItem('wrcallListPageSize', size);
	}

  selectCustomer(row:any){
		openWorkshopReassignmentDialog(this.dialog,row.customerName,row.customerTelephone,row.nearestWorkshop,row.chassisNumber,row.customerCode).subscribe(val=>{
			if(val == -1){
				this.ngOnInit();
			}
		});
	}

}
